import React, { createContext, useState, useContext, useEffect } from "react";
import { fetchUserData } from "../utils/fetchUserData";
import { callApi } from "../utils/apiService";
import { videoCreatorEndPoint, webEndPoint } from "../Constants/constants";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [passwordReset, setPasswordReset] = useState({
    email: "",
    resetToken: "",
  });

  const updateUser = (updatedData) => {
    setUser((prev) => ({
      ...prev,
      ...updatedData,
    }));
  };

  const setPasswordResetData = (data) => {
    setPasswordReset((prev) => ({
      ...prev,
      ...data,
    }));
  };

  const clearPasswordResetData = () => {
    setPasswordReset({
      email: "",
      resetToken: "",
    });
  };
  const clearUserData = () => {
    setUser(null);
    setDashboardData(null);
  };

   useEffect(() => {

      const fetchLanguages = async () => {
    try {
      const response = await callApi(
        `${videoCreatorEndPoint}language/list`,
        "GET"
      );

      if (response?.status) {
        setLanguages(response.data || []);
      }
    } catch (error) {
      console.error("Language API Error:", error);
    }
  };

      


  fetchLanguages();
   
  }, []);
  const accessToken = localStorage.getItem("accessToken");
  useEffect(() => {

    if (accessToken) {
      fetchUserData(setUser, setDashboardData);
    }
  }, [accessToken]);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        updateUser,
        passwordReset,
        setPasswordResetData,
        clearPasswordResetData,
        dashboardData,
        setDashboardData,
        clearUserData,
           languages,
    setLanguages,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
